import { FormActionButton } from '@workwave-tidal/core/form'

import { useResetEditingState } from '@/atoms'

import { form } from '../formState'
import { useTexts } from '../hooks/useTexts'

export function Footer() {
  const resetEditingState = useResetEditingState()
  const texts = useTexts()

  const {
    api,
    meta: { submitting, validating, status },
  } = form.useFormMeta()

  const isValuesNotChanged =
    JSON.stringify(api.getValues()) === JSON.stringify(api.getInitialValues())

  const saveDisabled = status === 'pristine' || validating || submitting || isValuesNotChanged

  return (
    <>
      <FormActionButton label={texts.cancel} size="medium" onClick={resetEditingState} />
      <FormActionButton
        label={texts.save}
        size="medium"
        variant="contained"
        type="submit"
        disabled={saveDisabled}
        loading={submitting || validating}
      />
    </>
  )
}
